import { Injectable } from '@angular/core';
import { UploadModel } from 'src/models/upload.model';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor() {}

  public upload_file(): Promise<UploadModel> {
    return new Promise((resolve, reject) => {
      let input_file = document.createElement('input');
      input_file.setAttribute('type', 'file');
      input_file.setAttribute('accept', '.rar,.zip');

      input_file.addEventListener('change', (_) => {
        const files = input_file.files;
        console.log("Files => ", files);
        
        if (files) resolve(this.onUploadHandler(files));
        else {
          reject('No files...');
          console.log("No files...");
          
        }
      });

      input_file.click();
    });
  }

  public onUploadHandler(files: FileList) {
    let struct_files: UploadModel;
    if (files && files.length) {
      struct_files = UploadModel.fromFile(files[0]);
    }
    console.log('File uploaded => ', struct_files);
    return struct_files;
  }
}
